import React from "react";
import DeviceDetails from "./DeviceDetails";
import GotoDetailsHeader from "./GotoDetailsHeader";

const DeviceDetailsDrawerContent = ({
  deviceData,
  onAssignUser,
  onAssignDepartment,
  onAssignLocation,
  canAssignLocation,
}) => {
  return (
    <>
      <GotoDetailsHeader
        title={deviceData?.name}
        subtitleLabel="Model"
        subtitle={deviceData?.modelName}
        status={deviceData?.isActive ? "Active" : "Inactive"}
      />

      <div className="mt-8">
        <DeviceDetails
          deviceData={deviceData}
          onAssignUser={onAssignUser}
          onAssignDepartment={onAssignDepartment}
          onAssignLocation={onAssignLocation}
          canAssignLocation={canAssignLocation}
        />
      </div>
    </>
  );
};

export default DeviceDetailsDrawerContent;
